import { loginUser, getUserdata, checkBookingSlots, getTravelCenters } from '../services/api'
import { router } from '../router/index'

const state = {
  token: '',
  user: {},
  travelCentres: [],
  travelCentresIreland: ['Cork','Dublin','Limerick'],
  vacancies: false,
  gotVacancies: false,
  sectionOpen: localStorage.getItem('sectionOpen')
    ? Number(localStorage.getItem('sectionOpen'))
    : 0,
  recruit: {
    title: '',
    firstname: '',
    surname: '',
    phoneHome: '',
    phoneMob: '',
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    postcode: '',
    rightToWork: false,
    centres:  [],
    email: '',
    qualifications: {
      qualification: '',
      qualificationWhen: '',
      qualificationWhere: '',
      qualification2: '',
      qualificationWhen2: '',
      qualificationWhere2: '',
      qualificationMath: '',
      otherMathQualification: '',
      gradeMath: '',
      qualificationEnglish: '',
      otherEnglishQualification: '',
      gradeEnglish: '',
    },
    previousEmployment: {
      currDuties: '',
      currEmployer: '',
      currEndDate: '',
      currFullPartTime: '',
      currJobTitle: '',
      currNotice: '',
      currNumHours: '',
      currSalary: '',
      currStartDate: '',
      currStillEmployed: false,
      currWhyLeave: '',
      preDatesFrom: '',
      preDatesTo: '',
      preDuties: '',
      preEmployer: '',
      preJobTitle: '',
      preWhyLeave: '',
      preSalary: '',
      otherExp: '',
    },
    workExamples: {
      workExampleRapport: '',
      workExampleSale: '',
      workExampleGeography: '',
      workExampleTech: '',
      workExampleEducation: '',
      workExampleManagement: '',
    },
    whereBeen: {
      whereAustralasia: '',
      whereAsia: '',
      whereAfrica: '',
      whereNorthAmerica: '',
      whereSouthAmerica: '',
      // whereEurope: ''
    },
    why: '',
    hearabout: '',
    hearaboutSearch: '',
    hearaboutOther: '',
    applicationComplete: {
      personal:  false,
      education:  false,
      employment:  false,
      work: false,
      where: false,
      why: false,
    },
    status: '',
    stage: '',
    // confirm: this.getRecruit ? this.getRecruit.confirm : false,
    ethnic: '',
    belfastcommunity:  '',
    belfastsex: '',
    whichImploded: '',
    belfastSelected: '',
    onboarding: {
      acceptanceDeadline: '',
      acceptanceLetter: {
        size: '',
        filename: '',
        mimetype: '',
        data: null
      },
      passportScan: {
        size: '',
        filename: '',
        mimetype: '',
        data: null
      },
      offerLetter: {
        size: '',
        filename: '',
        mimetype: '',
        data: null
      },
      onboardingComplete: {
        salary : false,
        details : false,
        starter : false,
        acceptance : false,
        apprenticeship: false,
        faq : false,
        corp : false,
        induction : false,
        accommodation : false
      },
      documentsToShow : [
        // "offerAcceptanceButton",
        // "yourDetails",
        // "salaryDetails",
        // "starterChecklist",
        // "apprenticeship",
        // "priorKnowledge",
        // "FAQs",
        // "generalInfo",
        // "dressStandards",
        // "accommodationInfo"
      ],
      confirmedTravelCentre: '',
      gradeOfSalary: '',
      additionalNotes: '',
      letterFrom:'',
      referenceDetails: '',
      startDate: '',
      onboardingForms: {
        acceptanceLetter: {
          accepted: false,
        },
        salaryForm : {
            IBAN : "",
            BIC : "",
            userAddress1 : "",
            userAddress2 : "",
            userAddress3 : "",
            userAddress4 : "",
            userPostcode : "",
            bankAddress1 : "",
            bankAddress2 : "",
            bankAddress3 : "",
            bankAddress4 : "",
            bankPostcode : "",
            tel : "",
            bank : "",
            accountNo : "",
            sortCode : "",
            ref : "",
            haveStudentLoan : "",
            loanType : "",
            payroll : "",
            payrollDeductionsYes : "",
            payrollDeductionsNo : "",
            valid : false
        },
        detailsForm : {
          nationalInsurance: '',
          title: '',
          firstForeName: '',
          secondForeName: '',
          surname: '',
          chosenName : '',
          middleNames: '',
          nationality : '',
          DOB : '',
          sex : '',
          nextOfKin : [],
          children : '',
          childrenDetails : [],
          dependant : '',
          dependantDetails : [],
          dependantLeave : '',
          languages : '',
          health : '',
          criminalConvictions : '',
          convictionDetails : '',
          refereeName : '',
          refereeCompany : '',
          refereeJobTitle : '',
          refereeEmail : '',
          valid : false
        },
        starterChecklist : {
          lastName : '',
          firstName : [
            {
              firstName : ''
            },
            
          ],
          DOB : '',
          userAddress1 : '',
          userAddress2 : '',
          userAddress3 : '',
          userAddress4 : '',
          userPostcode : '',
          nationalInsurance : '',
          startDate : '',
          statement : '',
          studentLoan : '',
          studentLoanQ2Statements: '',
          studentLoanType : '',
          fullName : '',
          date : '',
          valid : false
        },
        apprenticeship: {
          uniqueLearnerNumber: '',
          englishFileUpload: null,
          mathsFileUpload: null,
          noMathsCertificate: false,
          noEnglishCertificate: false,
        },
        priorKnowledge: {
          previousSalesConsultant: '',
          agencyName: '',
          howLong: '',
          travelQualifications: '',
          salesTraining: '',
          salesTrainingDetails: '',
          packageTravelRegulations: '',
          flightGDS: '',
          passportAndVisaExperience: '',
          FCDOAdviceExperience: '',
          localClimateExperience: '',
          californiaKnowledge: '',
          floridaKnowledge: '',
          westCanadaKnowledge: '',
          eastCoastAustraliaKnowledge: '',
          newZealandKnowledge: '',
          southAfricaKnowledge: '',
          thailandKnowledge: '',
          italyKnowledge: '',
          spainKnowledge: '',
          vietnamKnowledge: '',
          destinationKnowledge: '',
          flyDriveKnowledge: '',
          luxuryBeachKnowledge: '',
          familyKKnowledge: '',
          bespokePrivateKnowledge: '',
          escortedCoachingKnowledge: '',
          adventureGroupKnowledge: '',
          cruiseKnowledge: '',
          GAPYearKnowledge: '',
          businessClassFlightsKnowledge: '',
          railKnowledge: '',
          skiKnowledge: ''
        },
        corpGear : {
          documentRead : false
        },
        faq : {
          documentRead : false
        },
        accommodation : {
          provideAccommodation : '',
          giveNumber : ''
        },
        induction : {
          documentRead : false
        }
      }
    },
    auditTrail: [],
  },
  currentOnboardingForm: [
    'home',
    'acceptanceLetter',
    'detailsForm',
    'salaryForm',
    'apprenticeship',
    'priorKnowledge',
    'starterChecklist',
    'accommodation',
    'corporateGear',
    'induction',
    'faq',
  ],
  onboardingForms: {
    salaryForm: {
      DOB: '',
      IBAN: '',
      BIC: '',
      startDate: '',
      userAddress1: '',
      userAddress2: '',
      userAddress3: '',
      userAddress4: '',
      userPostcode: '',
      bankAddress1: '',
      bankAddress2: '',
      bankAddress3: '',
      bankAddress4: '',
      bankPostcode: '',
      tel: '',
      bank: '',
      accountNo: '',
      sortCode: '',
      ref: '',
      haveStudentLoan: '',
      loanType: '',
      payroll: '',
      payrollDeductionsYes: '',
      payrollDeductionsNo: '',
      valid: true,
    },
    detailsForm: {
      chosenName: '',
      nationality: '',
      DOB: '',
      sex: '',
      nextOfKin: [],
      NOK1Fullname: '',
      NOK1Relationship: '',
      NOK1Address1: '',
      NOK1Address2: '',
      NOK1Address3: '',
      NOK1Address4: '',
      NOK1Postcode: '',
      NOK1DayNumber: '',
      NOK1EveningNumber: '',
      NOK1MobileNumber: '',
      NOK2Fullname: '',
      NOK2Relationship: '',
      NOK2Address1: '',
      NOK2Address2: '',
      NOK2Address3: '',
      NOK2Address4: '',
      NOK2Postcode: '',
      NOK2DayNumber: '',
      NOK2EveningNumber: '',
      NOK2MobileNumber: '',
      children: '',
      childrenDetails: [],
      dependant: '',
      dependantDetails: [],
      dependantLeave: '',
      languages: '',
      health: '',
      criminalConvictions: '',
      convictionDetails: '',
      refereeName: '',
      refereeCompany: '',
      refereeJobTitle: '',
      refereeEmail: '',
      valid: true,
    },
    starterChecklist: {
      lastName: '',
      firstName: [],
      DOB: '',
      userAddress1: '',
      userAddress2: '',
      userAddress3: '',
      userAddress4: '',
      userPostcode: '',
      nationalInsurance: '',
      startDate: '',
      statement: '',
      studentLoan: '',
      studentLoanQ2Statements: '',
      studentLoanType: '',
      fullName: '',
      date: '',
      valid: true,
    },
    acceptanceLetter: {
      letter: '',
      fileUpload: '',
      valid: false
    },
    corpGear: {
      documentRead:'',
    },
    faq: {
      documentRead: '',
    },
    apprenticeship: {
      uniqueLearnerNumber: '',
      englishFileUpload: null,
      mathsFileUpload: null
    },
    priorKnowledge: {
      previousSalesConsultant: '',
      agencyName: '',
      howLong: '',
      travelQualifications: '',
      salesTraining: '',
      salesTrainingDetails: '',
      packageTravelRegulations: '',
      flightGDS: '',
      passportAndVisaExperience: '',
      FCDOAdviceExperience: '',
      localClimateExperience: '',
      californiaKnowledge: '',
      floridaKnowledge: '',
      westCanadaKnowledge: '',
      eastCoastAustraliaKnowledge: '',
      newZealandKnowledge: '',
      southAfricaKnowledge: '',
      thailandKnowledge: '',
      italyKnowledge: '',
      spainKnowledge: '',
      vietnamKnowledge: '',
      destinationKnowledge: '',
      flyDriveKnowledge: '',
      luxuryBeachKnowledge: '',
      familyKKnowledge: '',
      bespokePrivateKnowledge: '',
      escortedCoachingKnowledge: '',
      adventureGroupKnowledge: '',
      cruiseKnowledge: '',
      GAPYearKnowledge: '',
      businessClassFlightsKnowledge: '',
      railKnowledge: '',
      skiKnowledge: ''
    },
    accommodation: {
      provideAccommodation: '',
      giveNumber: '',
    },
    induction: {
      documentRead: '',
    },
  },
  onboardingComplete: {
    salary: false,
    details: false,
    starter: false,
    acceptance: false,
    priorKnowledgeComplete: false,
    apprenticeship: false,
    induction: false,
    faq: false,
    corp: false,
    accommodation: false,
  },
  onboardingSidebar: [],
  applicationReview: {
    reviewApplication: false,
    reviewApplicationComplete: false,
  },
  whereBeenValidated: false,
}

const getters = {
  isLoggedIn(state) {
    return !!state.token
  },
  getToken(state) {
    return state.token
  },
  getUser(state) {
    return state.user
  },
  getRecruit(state) {
    return state.recruit
  },
  getTravelCentres(state) {
    return state.travelCentres
  },
  getTravelCentresIreland(state) {
    return state.travelCentresIreland
  },
  getSectionOpen(state) {
    return state.sectionOpen
  },
  getOnboardingForm(state) {
    return state
  },
  getCurrentOnboardingForm(state) {
    return state.currentOnboardingForm
  },
  getApplicationComplete(state) {
    return state.recruit.applicationComplete
  },
  getOnboardingComplete(state) {
    return state.recruit.onboarding.onboardingComplete
  },
  getApplicationReview(state) {
    return state.applicationReview
  },
  getWhereBeenValidated(state) {
    return state.whereBeenValidated
  },
  getSelectedCenters(state) {
    return state.recruit.centres
  },
  getBelfastSelected(state) {
    return state.recruit.belfastSelected
  },
  getOnboardingSidebar(state) {
    return state.onboardingSidebar
  }
}

const actions = {
  async initAuth({ commit, dispatch }) {
    const token = localStorage.getItem('token')
    if (token) {
      const res = await getUserdata(token)
      if (!res) {
        dispatch('logoutAction')
      } else {
        commit('loginMutation', {
          user: res.data.user,
          token: token,
        })
        dispatch('authorizedAction')
        if (res.data.user && res.data.user.onboarding && res.data.user.onboarding.documentsToShow && res.data.user.onboarding.documentsToShow.length){
          dispatch('setOnboardingSidebarAction', res.data.user.onboarding.documentsToShow)
        }
        dispatch('setRecruitAction', res.data.user)
      }
    }
  },
  async authorizedAction({ dispatch }) {
    if (state.user) {
      // Check status of user and redirect accordingly
      if (state.user.status === 'passwordCreated') {
        router.push('/confirm-phone')
      }
      if (state.user.status === 'confirmed' || state.user.status === 'draft') {
        router.push('/application')
      }
      if (state.user.status === 'phoneInterview') {
        // If status is phoneInterview and booking slots have been selected then direct user to holding page
        const bookingSlots = await checkBookingSlots(state.token)
        if (
          bookingSlots.data &&
          bookingSlots.data.slots[0] &&
          bookingSlots.data.slots[0].type === 'phone'
        ) {
          router.push('/holding')
        } else {
          // if status is phoneInterview and no slots have been selected direct to calendar for phone interview
          router.push('/calendar-phone')
        }
      }
      if (state.user.status === 'faceToFaceInterview') {
        // If status is stage3 and booking slots have been selected then direct user to holding page
        const bookingSlots = await checkBookingSlots(state.token)
        if (
          bookingSlots.data &&
          bookingSlots.data.slots[1] &&
          bookingSlots.data.slots[1].type === 'f2f'
        ) {
          router.push('/holding')
        } else {
          // if status is stage3 and no slots have been selected direct to calendar for face to face interview
          router.push('/calendar-ftf')
        }
      }
      // If status is submitted or assessment direct user to holding page
      const onboardingStatuses = [
        "submitted",
        "assessment",
        "onboarding",
        "archived",
        "onboardingComplete",
        "referencesChased",
        "referencesRecieved",
        "referencesRequested"
      ];
      if (
        onboardingStatuses.includes(state.user.status)
      ) {
        const completedOnboardStatuses = ["onboardingComplete", "referencesChased", "referencesRecieved", "referencesRequested" ]
        if (completedOnboardStatuses.includes(state.user.status)) {
          router.push('/onboarding?complete=true')
        } else{
          router.push('/holding')
        }
      }
      // If status is onboarding direct user to onboarding page
      if (state.user.status === 'offerLetterSent' || state.user.status === 'onboardingInProgress') {
        // Open up onboarding docs on checklist
        dispatch(
          'authStore/sectionOpenAction',
          localStorage.getItem('sectionOpen')
            ? JSON.parse(localStorage.getItem('sectionOpen'))
            : 0,
          { root: true }
        )

        if (!window.location.href.includes('onboarding')) {
          router.push('/onboarding')
        }
      }
    }
  },
  async loginWithToken({ commit, dispatch }, token) {
    if (token) {
      const res = await getUserdata(token)
      if (!res) {
        dispatch('logoutAction')
      } else {
        const dataObj = {
          token,
          user: res.data.user,
        }
        // Store token
        localStorage.setItem('token', dataObj.token)

        commit('loginMutation', dataObj)
        if (!router.currentRoute.query.reset) {
          dispatch('authorizedAction')
        }
        if (dataObj.user && dataObj.user.onboarding && dataObj.user.onboarding.documentsToShow && dataObj.user.onboarding.documentsToShow.length){
          dispatch('setOnboardingSidebarAction', dataObj.user.onboarding.documentsToShow)
        }
        dispatch('setRecruitAction', dataObj.user)
        return res.data.user
      }
    }
  },
  async loginAction({ commit, dispatch }, userData) {
    try {
      const res = await loginUser(userData)
      if (res && res.data) {
        const dataObj = {
          token: res.data.token,
          user: res.data.user,
        }
        // Store token
        localStorage.setItem('token', dataObj.token)
        commit('loginMutation', dataObj)
        dispatch('authorizedAction')
        if (dataObj.user && dataObj.user.onboarding && dataObj.user.onboarding.documentsToShow && dataObj.user.onboarding.documentsToShow.length){
          dispatch('setOnboardingSidebarAction', dataObj.user.onboarding.documentsToShow)
        }
        dispatch('setRecruitAction', dataObj.user)
        dispatch('sectionOpenAction', 0);
        return res.data.user
      } else {
        return null
      }
    } catch (err) {
      return null
    }
  },
  async validateUserAction({ commit, rootState }, userData) {
    const dataObj = {
      token: userData.token,
      user: userData.user,
      rootState,
    }
    // Store token and user in local storage
    localStorage.setItem('token', dataObj.token)
    // localStorage.setItem('user', JSON.stringify(dataObj.user))
    commit('loginMutation', dataObj)
  },
  async logoutAction({ commit }) {
    try {
      await localStorage.clear()
      commit('logoutMutation')
      router.push('/login')
    } catch (err) {
      return null
    }
  },
   // This will be used to set the recruit object on app load
  setRecruitAction({ commit }, data) {
    commit('setRecruitMutation', data)
  },
  // This will be used to set the recruit object upon every input update
  updateRecruitAction({ commit }, data) {
    commit('updateRecruitMutation', data)
  },
  // This will update the address details in the recruit object when postcode lookup is used
  selectAddressAction({ commit }, data) {
    if (window.siteVar.referer === 'UK') {
      const addArray = data.address.split(',')
      if (data.isArray) {
        addArray.forEach((item, index) => {
          const dataObj = {
            item,
            input: `${data.addressOwner}Address${index + 1}`,
            postcode: data.postcode,
            formName: data.formName,
            addressOwner: data.addressOwner,
            isArray: data.isArray,
            formIndex: data.index,
            arrayName: data.arrayName,
            postcodeText: data.input,
          }
          commit('selectAddressMutation', dataObj)
        })
      } else {
        addArray.forEach((item, index) => {
          const dataObj = {
            item: item.trim(),
            input:
            data.formName === 'recruit'
            ? `address${index + 1}`
            : `${data.addressOwner}Address${index + 1}`,
            postcode: data.postcode,
            formName: data.formName,
            addressOwner: data.addressOwner,
          }
          commit('selectAddressMutation', dataObj)
        })
      }
    } else {
      if (data.isArray) {
        data.address.postalAddress.forEach((item, index) => {
          const dataObj = {
            item,
            input: `${data.input}Address${index + 1}`,
            postcode: data.address.postcode,
            formName: data.formName,
            addressOwner: data.addressOwner,
            isArray: data.isArray,
            formIndex: data.index,
            arrayName: data.arrayName,
            postcodeText: data.input,
          }
          commit('selectAddressMutation', dataObj)
        })
      } else {
        data.address.postalAddress.forEach((item, index) => {
          const dataObj = {
            item,
            input:
              data.formName === 'recruit'
                ? `address${index + 1}`
                : `${data.addressOwner}Address${index + 1}`,
            postcode: data.address.postcode,
            formName: data.formName,
            addressOwner: data.addressOwner,
          }
          commit('selectAddressMutation', dataObj)
        })
      }
    }
  },
  async setTravelCentresAction({ commit }) {
    const res = await getTravelCenters()
    const payloadObj = {
      tc: res,
    }
    commit('setTravelCentresMutation', payloadObj)
  },
  setAllUKOrIETravelCentersAction({ commit }, payload) {
    commit('setAllUKOrIETravelCentersMutation', payload)
  },
  setNoJobDropdownAction({ commit }, index) {
    commit('setNoJobDropdownMutation', index)
  },
  updateBelfastSelectedAction({ commit }, data) {
    commit('updateBelfastSelectedMutation', data)
  },
  sectionOpenAction({ commit }, section) {
    localStorage.setItem('sectionOpen', section)
    commit('sectionOpenMutation', section)
    window.scroll({
      top: 0,
      behavior: 'smooth',
    })
  },
  setStatusAction({ commit }, status) {
    commit('setStatusMutation', status)
  },
  removeApplicationDataAction({ commit }) {
    commit('removeApplicationDataMutation')
  },
  updateOnboardingFormAction({ commit }, data) {
    commit('updateOnboardingFormMutation', data)
  },
  currentOnboardingFormAction({ commit }, data) {
    commit('currentOnboardingFormMutation', data)
  },
  createNextOfKinAction({ commit }) {
    commit('createNextOfKinMutation')
  },
  removeNextOfKinAction({ commit }, data) {
    commit('removeNextOfKinMutation', data)
  },
  createChildAction({ commit }) {
    commit('createChildMutation')
  },
  removeChildAction({ commit }, data) {
    commit('removeChildMutation', data)
  },
  createDependantAction({ commit }) {
    commit('createDependantMutation')
  },
  removeDependantAction({ commit }, data) {
    commit('removeDependantMutation', data)
  },
  createNameAction({ commit }) {
    commit('createNameMutation')
  },
  removeNameAction({ commit }, data) {
    commit('removeNameMutation', data)
  },
  updateApplicationCompleteAction({ commit, state }, data) {
    localStorage.setItem(
      'applicationComplete',
      JSON.stringify(state.recruit.applicationComplete)
    )
    // Save to local storage
    commit('updateApplicationCompleteMutation', data)
  },
  updateOnboardingCompleteAction({ commit, state }, data) {
    localStorage.setItem(
      'onboardingComplete',
      JSON.stringify(state.recruit.onboarding.onboardingComplete)
    )
    // Save to local storage
    commit('updateOnboardingCompleteMutation', data)
  },
  applicationReviewAction({ commit }, data) {
    commit('applicationReviewMutation', data)
  },
  whereBeenValidatedAction({ commit }, data) {
    commit('whereBeenValidatedMutation', data)
  },

  acceptanceLetterAction({ commit }, data) {
    commit('acceptanceLetterMutation', data)
  },
  updateAuditTrailAction({commit}, data){
    commit('updateAuditTrailMutation', data)
  },
  setNextOfKinAddressAction({ commit }, data) {
    commit('setNextOfKinAddressMutation', data)
  },
  setStageAction ({ commit }, data) {
    commit('setStageMutation', data)
  },
  setOnboardingSidebarAction({ commit }, data) {
    commit('setOnboardingSidebarMutation', data)
  }
}

const mutations = {
  async loginMutation(state, payload) {
    state.token = payload.token
    state.user = payload.user
  },
  logoutMutation(state) {
    state.token = ''
    state.user = ''
  },
  updateRecruitMutation(state, payload) {
    // Remove onboarding otherwise submission will be rejected
    const onboardingCompleteStatuses = ["onboardingComplete", "referencesChased", "referencesRecieved", "referencesRequested" ];
    if (payload.onboarding && state.recruit.status !== 'offerLetterSent' && state.recruit.status !== 'onboardingInProgress' && !onboardingCompleteStatuses.includes(state.recruit.status)) {
      delete payload.onboarding
    }
    // Need to update accordingly if a nested propery or not
    if (payload.category) {
      state.recruit[payload.category][payload.input] = payload.value
    } else {
      state.recruit[payload.input] = payload.value
    }
  },
  setRecruitMutation(state, payload) {
    const onboardingCompleteStatuses = ["onboardingComplete", "referencesChased", "referencesRecieved", "referencesRequested" ];
    // Remove onboarding otherwise submission will be rejected
    if (payload.onboarding && state.recruit.status !== 'offerLetterSent' && state.recruit.status !== 'onboardingInProgress' && !onboardingCompleteStatuses.includes(state.recruit.status)) {
      delete payload.onboarding
    }
    // Use Object.assign as we want to merge our changes rather than overwrite the recruit object
    Object.assign(state.recruit, payload)
  },
  selectAddressMutation(state, payload) {
    if (payload.isArray) {
      state.recruit.onboarding.onboardingForms[payload.formName][payload.arrayName][
        payload.formIndex
      ][payload.input] = payload.item
      state.recruit.onboarding.onboardingForms[payload.formName][payload.arrayName][
        payload.formIndex
      ][`${payload.postcodeText}Postcode`] = payload.postcode
    } else if (
      payload.formName === 'salaryForm' ||
      payload.formName === 'detailsForm' ||
      payload.formName === 'starterChecklist' ||
      payload.formName === 'acceptanceLetter'
    ) {
      state.recruit.onboarding.onboardingForms[payload.formName][payload.input] = payload.item
      state.recruit.onboarding.onboardingForms[payload.formName][
        payload.formName === 'recruit'
          ? 'postcode'
          : `${payload.addressOwner}Postcode`
      ] = payload.postcode
    } else {
      state[payload.formName][payload.input] = payload.item
      state[payload.formName][
        payload.formName === 'recruit'
          ? 'postcode'
          : `${payload.addressOwner}Postcode`
      ] = payload.postcode
    }
  },
  setTravelCentresMutation(state, payload) {
    state.travelCentres = payload.tc
  },
  setAllUKOrIETravelCentersMutation(state, payload) {
    state.recruit.centres = payload
  },
  setNoJobDropdownMutation(state, payload) {
    state.travelCentres[payload].dropdownOpen = !state.travelCentres[payload]
      .dropdownOpen
  },
  updateBelfastSelectedMutation(state, payload) {
    state.recruit.belfastSelected = payload
  },
  sectionOpenMutation(state, payload) {
    state.sectionOpen = payload
  },
  setStatusMutation(state, payload) {
    state.recruit.status = payload
  },
  removeApplicationDataMutation(state) {
    delete state.recruit.applicationData
  },
  updateOnboardingFormMutation(state, payload) {
    // Check if array
    if (payload.array) {
      state.recruit.onboarding.onboardingForms[payload.form][payload.input][payload.index][
        payload.item
      ] = payload.value
    } else {
      state.recruit.onboarding.onboardingForms[payload.form][payload.input] = payload.value
    }
  },
  currentOnboardingFormMutation(state, payload) {
    Object.assign(state.recruit.onboarding.onboardingForms, payload.onboardingForms)
    Object.assign(state.recruit.onboarding.onboardingComplete, payload.onboardingComplete)
  },
  createNextOfKinMutation(state) {
    state.recruit.onboarding.onboardingForms.detailsForm.nextOfKin.push({
      [`NOKFullname`]: '',
      [`NOKRelationship`]: '',
      [`NOKAddress1`]: '',
      [`NOKAddress2`]: '',
      [`NOKAddress3`]: '',
      [`NOKAddress4`]: '',
      [`NOKPostcode`]: '',
      [`NOKDayNumber`]: '',
      [`NOKEveningNumber`]: '',
      [`NOKMobileNumber`]: '',
    })
  },
  removeNextOfKinMutation(state, index) {
    state.recruit.onboarding.onboardingForms.detailsForm.nextOfKin.splice(index)
  },
  createChildMutation(state) {
    state.recruit.onboarding.onboardingForms.detailsForm.childrenDetails.push({
      [`childFullname`]: '',
      [`childDOB`]: '',
    })
  },
  removeChildMutation(state, index) {
    state.recruit.onboarding.onboardingForms.detailsForm.childrenDetails.splice(index)
  },
  createDependantMutation(state) {
    state.recruit.onboarding.onboardingForms.detailsForm.dependantDetails.push({
      [`dependantFullname`]: '',
      [`dependantRelationship`]: '',
    })
  },
  removeDependantMutation(state, index) {
    state.recruit.onboarding.onboardingForms.detailsForm.dependantDetails.splice(index)
  },
  createNameMutation(state) {
    state.recruit.onboarding.onboardingForms.starterChecklist.firstName.push({
      [`firstName`]: '',
    })
  },
  removeNameMutation(state, index) {
    state.recruit.onboarding.onboardingForms.starterChecklist.firstName.splice(index)
  },
  updateApplicationCompleteMutation(state, payload) {
    state.recruit.applicationComplete[payload.section] = payload.status
  },
  updateOnboardingCompleteMutation(state, payload) {
    state.recruit.onboarding.onboardingComplete[payload.section] = payload.status
  },
  applicationReviewMutation(state, payload) {
    state.applicationReview[payload.input] = payload.status
  },
  whereBeenValidatedMutation(state, payload) {
    state.whereBeenValidated = payload
  },
  acceptanceLetterMutation(state, payload) {
    state.acceptanceLetter.fileName = payload.fileName
  },
  updateAuditTrailMutation(state){
    let _date = new Date();
    state.recruit.auditTrail.push(_date)
  },
  setNextOfKinAddressMutation(state, payload) {
    state.recruit.onboarding.onboardingForms.detailsForm[`${payload.prefix}Address1`] = payload.address1
    state.recruit.onboarding.onboardingForms.detailsForm[`${payload.prefix}Address2`] = payload.address2
    state.recruit.onboarding.onboardingForms.detailsForm[`${payload.prefix}Address3`] = payload.address3
    state.recruit.onboarding.onboardingForms.detailsForm[`${payload.prefix}Address4`] = payload.address4
    state.recruit.onboarding.onboardingForms.detailsForm[`${payload.prefix}Postcode`] = payload.postcode
  },
  setStageMutation (state, payload) {
    state.recruit.stage = payload
  },
  setOnboardingSidebarMutation (state, payload){
    state.onboardingSidebar = payload;
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}
